/**
 * Utility functions for ArchiMate diagram management
 */

import type { ArchiMateDiagram } from './types';
import type { ExtendedArchiMateDiagram } from './extended-types';

/**
 * Ensures a diagram has all extended properties initialized
 * This prevents undefined access errors when working with extended features
 */
export function ensureExtendedDiagram(
  diagram: ArchiMateDiagram | ExtendedArchiMateDiagram
): ExtendedArchiMateDiagram {
  const extended = diagram as ExtendedArchiMateDiagram;

  return {
    ...extended,
    // Ensure all extended properties exist with defaults
    tags: extended.tags || [],
    elementMetadata: extended.elementMetadata || {},
    relationshipMetadata: extended.relationshipMetadata || {},
    adrs: extended.adrs || [],
    scenarios: extended.scenarios || [],
    teams: extended.teams || [],
    rules: extended.rules || [],
    violations: extended.violations || [],
    changelog: extended.changelog || [],
    stakeholderViews: extended.stakeholderViews || [],
  };
}

/**
 * Creates a new empty extended diagram with all properties initialized
 */
export function createExtendedDiagram(name: string = 'Untitled Diagram'): ExtendedArchiMateDiagram {
  return {
    id: '', // Will be set by caller using nanoid()
    name,
    elements: [],
    relationships: [],
    createdAt: Date.now(),
    updatedAt: Date.now(),
    tags: [],
    elementMetadata: {},
    relationshipMetadata: {},
    adrs: [],
    scenarios: [],
    teams: [],
    rules: [],
    violations: [],
    changelog: [],
    stakeholderViews: [],
  };
}
